import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const STEPS = [
    {
        n: "01",
        t: "Create Your Account",
        d: "Join the TAVONX ecosystem.",
        tid: "timeline-step-1",
    },
    {
        n: "02",
        t: "Fund Your Account",
        d: "Access the assets and markets available on the platform.",
        tid: "timeline-step-2",
    },
    {
        n: "03",
        t: "Start Trading",
        d: "Explore digital asset markets through the TAVONX experience.",
        tid: "timeline-step-3",
    },
];

export default function HowItWorks() {
    return (
        <section id="how-it-works" data-testid="getting-started-section" className="relative bg-void py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
                <div className="mx-auto max-w-3xl text-center">
                    <Reveal>
                        <Eyebrow className="justify-center">Getting Started</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="font-grotesk text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl">
                            Start in <span className="text-grad-blue">minutes.</span>
                        </h2>
                    </Reveal>
                </div>

                <div className="relative mt-20">
                    {/* connecting timeline */}
                    <div className="absolute left-0 right-0 top-6 hidden h-px bg-white/[0.07] md:block">
                        <motion.div
                            initial={{ scaleX: 0 }}
                            whileInView={{ scaleX: 1 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
                            className="h-full w-full origin-left bg-gradient-to-r from-electric via-cyber to-vio"
                        />
                    </div>

                    <div className="grid gap-12 md:grid-cols-3 md:gap-8">
                        {STEPS.map((s, i) => (
                            <Reveal key={s.n} delay={0.15 + i * 0.18}>
                                <div data-testid={s.tid} className="relative md:pr-6">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-full border border-cyber/30 bg-base font-mono text-sm text-cyber shadow-[0_0_24px_rgba(0,209,255,0.15)]">
                                        {s.n}
                                    </div>
                                    <h3 className="mt-7 font-grotesk text-lg font-bold uppercase tracking-[0.14em] text-white">
                                        {s.t}
                                    </h3>
                                    <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-400">
                                        {s.d}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                <Reveal delay={0.4} className="mt-16 flex justify-center">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            open("signup");
                        }}
                        data-testid="timeline-cta-get-started"
                        className="group inline-flex items-center gap-2 rounded bg-gradient-to-r from-electric to-cyber px-9 py-4 font-grotesk text-sm font-semibold uppercase tracking-[0.18em] text-void transition-all duration-300 hover:shadow-[0_0_36px_rgba(0,209,255,0.35)]"
                    >
                        Get Started
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
